import { translation as t } from 'consts'

export default async ({ props, translator }) => {
  const URL = process.env.REACT_APP_TRANSLATOR_URL || '/translator'
  await translator.bootstrap(
    URL,
    t.system,
    props.user.locale,
    t.namespaces,
    props.client.name
  )
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/setLanguage.js